import FlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
export default {
  name: 'DateInput',
  components: {
    FlatPickr: FlatPickr
  },
  setup: function setup(props) {
    var date = ref(props.value);
    return {
      date: date
    };
  },
  props: {
    name: {
      required: true,
      type: String
    },
    label: {
      required: false,
      type: String
    },
    placeholder: {
      default: 'Select Date',
      required: false,
      type: String
    },
    value: {
      required: false,
      type: [Date, String]
    },
    error: {
      default: '',
      required: false,
      type: String
    },
    disabled: {
      required: false,
      type: Boolean
    },
    min: {
      default: null,
      required: false,
      type: [String, Date]
    }
  },
  computed: {
    config: function config() {
      return {
        dateFormat: 'd-m-Y',
        altFormat: 'd-m-Y',
        altInput: true,
        minDate: this.min,
        disableMobile: 'true'
      };
    }
  },
  watch: {
    value: function value() {
      this.date = this.value;
    }
  },
  methods: {
    updateValue: function updateValue() {
      this.$emit('input', this.date);
    }
  }
};